import {values} from 'lodash';

import {useAppSelector} from '../../../helpers/reduxHelpers';
import {
  getShouldAddTeamInbox,
  getShouldAddTeammate,
  getShouldExploreSettings,
} from '../../../store/stateless/startGuideSelectors';

export const taskProgressComplete = 100;
export const totalTaskCount = 3;

interface TaskCompletionProgress {
  shouldAddTeamInbox: boolean;
  shouldAddTeammate: boolean;
  shouldExploreRules: boolean;
  progress: number;
}

export function useTaskCompletionProgress() {
  const shouldAddTeamInbox = useAppSelector(getShouldAddTeamInbox);
  const shouldAddTeammate = useAppSelector(getShouldAddTeammate);
  const shouldExploreRules = useAppSelector(getShouldExploreSettings);

  const taskCompletionMap = {
    teamInboxTask: !shouldAddTeamInbox,
    teammateTask: !shouldAddTeammate,
    ruleTask: !shouldExploreRules,
  };

  const numCompletedTasks = values(taskCompletionMap).filter(Boolean).length;
  const progress = Math.floor((numCompletedTasks / values(taskCompletionMap).length) * 100);
  const completionProgress: TaskCompletionProgress = {
    shouldAddTeamInbox,
    shouldAddTeammate,
    shouldExploreRules,
    progress,
  };
  return completionProgress;
}
